import React, { createContext, useState } from 'react'
import {BrowserRouter,Routes,Route, RouterProvider} from 'react-router-dom'
import Services from './components/services/Servi.jsx'
import Portfolio from './components/Portfolio'

import Header from './components/Header'
import Footer from './components/Footer'
import Videoedit from './components/edit/videoedit.jsx'
import Photoedit from './components/edit/photoedit.jsx'
import Projects from './components/projects/projects.jsx'
import Aboutt from './components/about/about.jsx'
import Resumee from './components/resume/resume.jsx'


export const UserContext=createContext("");


function App() {
  
  const [theme,setTheme] = useState(null);
  const [padding,setPadding]=useState(0);
  const [nav,setNav]=useState(0);
  return (
    <UserContext.Provider value={{theme,setTheme,padding,setPadding,nav,setNav}} >
      <BrowserRouter>
 
    <div>
    <Header/>
    </div>
    <Routes>
      <Route path="/" element={<Portfolio/>}/>
      <Route  path="/projects" element={<Projects/>} />
      <Route  path="/services" element={<Services/>} />
      <Route path="/videoedits" element={<Videoedit/>} />
      <Route path="/photoedits" element={<Photoedit/>} />
      <Route path='/about' element={<Aboutt/>}/>
      <Route path='/resume' element={<Resumee/>}/>

    </Routes>
    <div>
      <Footer/>
    </div>
    </BrowserRouter>
    </UserContext.Provider>

    
  )
}

export default App
